import { SPM_POSITION_OFFSET, type SpmModuleCodes } from './types';

/** 解析明确编码或按编号模板生成完整坑位编码（A.B.C.D）。 */
export function resolveSpmPositionCode(
  moduleCodes: SpmModuleCodes | undefined,
  position: string,
): string | undefined {
  if (!moduleCodes) return undefined;

  const exact = moduleCodes[position];
  if (typeof exact === 'string' && exact) return exact;

  // 模板键使用 {NN}/{NNN} 表示序号的最小位数，超过位数时不截断。
  const templates = Object.keys(moduleCodes).filter((key) => key.includes('{N'));
  for (const templateKey of templates) {
    const parts = templateKey.split(/(\{N+\})/);
    let pattern = '^';
    const widths: number[] = [];
    let validTemplate = true;

    for (const part of parts) {
      const placeholder = /^\{(N+)\}$/.exec(part);
      if (placeholder) {
        widths.push(placeholder[1].length);
        pattern += '(\\d+)';
      } else if (/^[a-z_]*$/.test(part)) {
        pattern += part;
      } else {
        validTemplate = false;
        break;
      }
    }
    if (!validTemplate || widths.length === 0) continue;

    const match = new RegExp(pattern + '$').exec(position);
    if (!match) continue;

    const ordinals = match.slice(1).map(Number);
    if (ordinals.some((ordinal) => !Number.isSafeInteger(ordinal) || ordinal < 1)) {
      return undefined;
    }

    const productListOrdinal = /^(product|favorite|try_on)_(\d+)$/.exec(position);
    const positionOffset = moduleCodes[SPM_POSITION_OFFSET] ?? 0;
    if (positionOffset > 0 && productListOrdinal) {
      ordinals[0] += positionOffset;
      if (!Number.isSafeInteger(ordinals[0])) return undefined;
    }

    const value = moduleCodes[templateKey];
    if (typeof value !== 'string' || !value) return undefined;

    let index = 0;
    return value.replace(/\{N+\}/g, (placeholder) => {
      const ordinal = ordinals[index];
      const width = widths[index];
      index += 1;
      return String(ordinal).padStart(width, '0');
    });
  }

  return undefined;
}
